document.addEventListener('DOMContentLoaded', () => {

  const DEFAULT_LOCALE = 'ja';
  const LOCALE_PREFIXES = {
    ja: '',
    en: '/en'
  };

  const getCurrentPrefix = () => {
    const known = Object.values(LOCALE_PREFIXES).filter(p => p); 
    for (const p of known) {
      if (window.location.pathname === p || window.location.pathname.startsWith(p + '/')) {
        return p;
      }
    }
    return '';
  };

  const stripExistingPrefix = (path) => {
    const known = Object.values(LOCALE_PREFIXES).filter(p => p);
    for (const p of known) {
      if (path === p) return '/';
      if (path.startsWith(p + '/')) return path.slice(p.length);
    }
    return path;
  };

  const switchLocale = (code) => {
    localStorage.setItem('preferred_locale', code);
    const prefix = LOCALE_PREFIXES[code] !== undefined ? LOCALE_PREFIXES[code] : `/${code}`;
    const newPath = stripExistingPrefix(window.location.pathname);
    const dest = `${prefix}${newPath}` + window.location.search + window.location.hash;
    window.location.href = dest;
  };

  // URLから現在の言語を取得
  const getCurrentLocale = () => {
    const currentPrefix = getCurrentPrefix();
    for (const [locale, prefix] of Object.entries(LOCALE_PREFIXES)) {
      if (prefix === currentPrefix) {
        return locale;
      }
    }
    return DEFAULT_LOCALE;
  };

  // ポップアップから使用するユーティリティ関数をエクスポート
  window.languageUtils = {
    switchLocale: switchLocale,
    getCurrentLocale: getCurrentLocale,
    LOCALE_PREFIXES: LOCALE_PREFIXES,
    DEFAULT_LOCALE: DEFAULT_LOCALE
  };

  // ヘッダーの言語ボタンクリック時にポップアップを表示
  const langButton = document.querySelector('.icon-group__language');
  const langButtonSP = document.querySelector('.mobile-header-language-btn');
  if (langButton) {
    langButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (window.languagePopup && window.languagePopup.show) {
        window.languagePopup.show();
      }
    });
  }
  if (langButtonSP) {
    langButtonSP.addEventListener('click', (e) => {
      e.preventDefault();
      if (window.languagePopup && window.languagePopup.show) {
        window.languagePopup.show();
      }
    });
  }

  // クリックした内部リンクに選択言語のプレフィックスを付与
  document.body.addEventListener('click', (event) => {
    const anchor = event.target.closest('a');
    if (!anchor) return;
    if (anchor.target === '_blank' || anchor.hasAttribute('download')) return;

    try {
      const url = new URL(anchor.href, window.location.href);
      if (url.origin !== window.location.origin) return;

      const saved = localStorage.getItem('preferred_locale');
      if (!saved || !LOCALE_PREFIXES.hasOwnProperty(saved)) return;
      const desiredPrefix = LOCALE_PREFIXES[saved];

      const urlHasDesired = desiredPrefix && (url.pathname === desiredPrefix || url.pathname.startsWith(desiredPrefix + '/'));
      const urlHasNoKnown = !desiredPrefix && !Object.values(LOCALE_PREFIXES).some(p => p && (url.pathname === p || url.pathname.startsWith(p + '/')));
      if (urlHasDesired || urlHasNoKnown) return; // OK

      event.preventDefault();
      let newPath = stripExistingPrefix(url.pathname);
      url.pathname = `${desiredPrefix}${newPath}`;
      window.location.href = url.toString();
    } catch (err) {}
  });

  // --- 保存済み言語設定に基づく自動リダイレクト ---
  (() => {
    const saved = localStorage.getItem('preferred_locale');
    
    // 言語設定が存在する場合のみURLリダイレクトを処理
    if (saved && LOCALE_PREFIXES.hasOwnProperty(saved)) {
      const savedPrefix = LOCALE_PREFIXES[saved];
      const currentPrefix = getCurrentPrefix();
      
      // 現在のURLが保存済み言語と一致しない場合はリダイレクト
      if (savedPrefix !== currentPrefix) {
        const cleanPath = stripExistingPrefix(window.location.pathname);
        const dest = `${savedPrefix}${cleanPath}` + window.location.search + window.location.hash;
        window.location.replace(dest);
      }
    }
  })();
}); 